import { render, staticRenderFns } from "./tankAction.vue?vue&type=template&id=68b12e62&scoped=true&"
import script from "./tankAction.vue?vue&type=script&lang=js&"
export * from "./tankAction.vue?vue&type=script&lang=js&"
import style0 from "./tankAction.vue?vue&type=style&index=0&id=68b12e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b12e62",
  null
  
)

export default component.exports